import * as React from "react";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import LoginIdForm, { ILoginIdFormProps } from "../forms/loginIdForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface ILoginIdScreenProps extends ILoginIdFormProps {
  onClose?: () => void;
}

const LoginWithApi: React.FC<ILoginIdScreenProps> = (props) => {
  return (
    <div className="loginWithApi">
      <div className="loginWithApi_container">
        <div className="loginWithApi_head">
          <span>
            <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
          </span>
          <span>
            <i className="edel-icon-close" onClick={props.onClose}></i>
          </span>
        </div>
        <div className="loginWithApi_contant">
          <LoginIdForm {...props} />
        </div>
      </div>
    </div>
  );
};

export default LoginWithApi;
